import styled from '@emotion/styled';
import { Form } from 'antd';

export const SadaKForm = styled(Form)`
  .ant-input-group {
    display: flex;
  }
`;
